import { em, rem } from 'polished'
import styled from 'styled-components'

import { ImporterCriteriaContainerStyled } from './ImporterCriteriaContainerStyled'

interface IImporterContentStyledProps {
  width?: number
}

export const ImporterContentStyled = styled.div<IImporterContentStyledProps>`
  font-size: ${rem(16)};

  text-align: center;

  margin: 0 auto;
  width: ${(props) => (props.width ? em(props.width) : '100%')};
  min-height: ${em(240)};

  ${ImporterCriteriaContainerStyled} {
    width: ${em(480)};

    margin: 0 auto;
  }

  img {
    max-height: 6em;
  }
`
